export default {
  copyAddress: {
    id: 'track_parcel_copy_address',
    defaultMessage: 'Copy address',
  },
  addressCopied: {
    id: 'track_parcel_address_copied',
    defaultMessage: 'Address copied',
  },
}
